module.exports = __webpack_public_path__ + "static/media/octopus.ba02863b.png";